import { NO_INTERMEDIATE_STOP_TRANSPORT_MODES } from '@data/transportModesTypes'

export function routeWaypoints(state) {
    return state.routeWaypoints
}

export function startWaypoint(state) {
    return state.routeWaypoints[0]
}

export function interimWaypoints(state) {
    return state.routeWaypoints.slice(1, -1);
}

export function endWaypoint(state) {
    return state.routeWaypoints[state.routeWaypoints.length - 1]
}

export function routesLoading(state) {
    return state.routesLoading
}

export function selectedTransportModeKeys(state) {
    let selectedTransportModeKeys = [];
    for (const modeKey in state.transportModes) {
        if(state.transportModes[modeKey].selected) {
            selectedTransportModeKeys.push(modeKey);
        }
    }
    return selectedTransportModeKeys
}

export function manualTransportModes(state) {
    return state.manualTransportModes;
}

export function activeRouteId(state) {
    return state.activeRouteId
}

export function activeRouteMode(state) {
    return state.activeRouteMode
}

export function activeTransportModeTab(state) {
    return state.activeTransportModeTab
}

export function transportModes(state) {
    return state.transportModes
}

export function someTransportModesLoaded(state) {
    let someLoaded = false;
    for (const modeKey in state.transportModes) {
        if(state.transportModes[modeKey].routes.length || state.transportModes[modeKey].error) {
            someLoaded = true;
            return true;
        }
    }
    return someLoaded;
}

export function routeCorridor(state) {
    return state.routeCorridor
}

export function detailRouteId(state) {
    return state.detailRouteId
}

export function routeShortTermParkingZone(state) {
    return state.routeShortTermParkingZone
}

export function routeCountryInfos(state) {
    return state.routeCountryInfos
}

export function routeGreenzones(state) {
    return state.routeGreenzones
}

export function activeTransportModeNoIntermediateStops(state) {
    return NO_INTERMEDIATE_STOP_TRANSPORT_MODES.indexOf(state.activeTransportModeTab) >= 0
}

export function activeRouteSectionPolylines(state) {
    let data = false
    if(state.activeTransportModeTab && state.activeRouteId) {
       const activeRoute = state.transportModes[state.activeTransportModeTab].routes.find(route => route.id === state.activeRouteId)
       if(activeRoute) data = activeRoute.sections.map(section => { return { polyline: section.polyline, polylineWKT: section.polylineWKT }})
    }
    return data
}